/**
 * @module common/components/pager
 */
import React, { PropTypes, Component } from 'react';
import classnames from 'classnames';
import { TextInputField } from 'common/components/form_fields';
import { Field } from 'redux-form';
import partial from 'lodash/partial';
import queryString from 'query-string';
import Icon from 'common/components/svg_icon';
import omit from 'lodash/omit';

export default class Pager extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handlePageChange(values, e) {
    if (e.preventDefault) e.preventDefault();
    const { page } = values;
    const { location, router } = this.props;
    const searches = queryString.parse(location.search);
    const params = page > 1 ? { ...searches, page } : { ...omit(searches, 'page') };
    const search = queryString.stringify(params);

    router.push({
      pathname: location.pathname,
      search: `?${search}`,
    });

    this.props.onPageChange(page);
  }

  handleClick(page, e) {
    const { change } = this.props;
    // this is here to update the value in the text box
    change('page', page);

    // this is here to update the route and state
    this.handlePageChange({ page }, e);
    this.setState({});
  }

  render() {
    const { currentPage, pageCount, handleSubmit } = this.props;

    if (!pageCount) {
      return null;
    }

    const prevPage = partial(this.handleClick, currentPage - 1);
    const nextPage = partial(this.handleClick, currentPage + 1);
    const lastPage = partial(this.handleClick, pageCount);

    const prevClasses = classnames('btn btn-utility btn-lg btn-with-icon', {
      invisible: currentPage === 1
    });

    const nextClasses = classnames('btn btn-utility btn-lg btn-with-icon', {
      invisible: currentPage === pageCount
    });

    return (
      <form className="pagination" onSubmit={handleSubmit(this.handlePageChange)}>
        <button onClick={prevPage} type="button" className={prevClasses}>
          <Icon icon="arrowLeft" />
          {' '}<span className="hide-for-small-only">Prev</span>
        </button>
        <div className="pages">
          <Field
            component={TextInputField}
            name="page"
          />
          <div className="page-count">of{' '}
            <button type="button" className="last-page" onClick={lastPage}>{pageCount}</button>
          </div>
        </div>
        <button onClick={nextPage} type="button" className={nextClasses}>
          <span className="hide-for-small-only">Next</span>{' '}
          <Icon icon="arrowRight" />
        </button>
      </form>);
  }
}

Pager.propTypes = {
  location: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  pageCount: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
};
